import cn from 'classnames'
import { isNumber } from 'lodash'

import Link from 'components/link'
import css from 'components/product-tag/product-tag.module.scss'

import { useTranslate } from 'hooks'

import { ROUTES } from 'constants/routes'

type ProductTagProps = {
  showPercentage?: boolean
  onSalePercentage?: number | null
  isBestSeller?: boolean
  isNew?: boolean
  className?: string
  size?: 'sm' | 'md'
  promotion?: {
    name: string
    key: string
  }
}

const PROMOTION_URL = ROUTES.SEARCH_PRODUCTS + '?onsale=1%3A100'

const ProductTag = ({
  onSalePercentage,
  showPercentage = true,
  isBestSeller,
  isNew,
  className,
  size = 'sm',
  promotion,
}: ProductTagProps) => {
  const { t } = useTranslate('common')
  const isShowSale = isNumber(onSalePercentage) && onSalePercentage > 0

  return (
    <div className={cn(css.container, css[`container--${size}`], className)}>
      {!!isShowSale && (
        <Link className={css.sale} href={PROMOTION_URL} target="_blank">
          {showPercentage ? (
            <span className={css.text}>{t('tag.sale_off', { percentage: onSalePercentage })}</span>
          ) : (
            <span className={css.text}>{t('tag.sale')}</span>
          )}
        </Link>
      )}

      {!!promotion && (
        <Link
          className={cn([css.sale, css.promotion])}
          href={`${ROUTES.SEARCH_PROMOTION}/${promotion.key}`}
          target="_blank"
        >
          <span className={css.text}>{promotion.name}</span>
        </Link>
      )}

      {!!isBestSeller && (
        <Link
          className={cn([css.bestSeller, isShowSale && isNew && css.hideInMobile])}
          href={ROUTES.SEARCH_PRODUCTS_BEST_SELLERS}
          target="_blank"
        >
          <span className={css.text}>{t('tag.best_seller')}</span>
        </Link>
      )}

      {!!isNew && (
        <Link className={css.newPublish} href={ROUTES.SEARCH_PRODUCTS_NEW} target="_blank">
          <span className={css.text}>{t('tag.new')}</span>
        </Link>
      )}
    </div>
  )
}

export default ProductTag
